import React from 'react';
import { Grid, Cell } from 'react-foundation';
import { useNavigate } from 'react-router-dom';
import { Header } from '../../constants/SharedComponents';
import { useDemoContext } from '../../contexts/DemoContext';

export function DemoChooseYourRoute() {
  const navigate = useNavigate();
  const { nextDemoStep } = useDemoContext();

  const handleGuidedRoute = () => {
    nextDemoStep();
    // Navigate to guided route demo (full questions intro)
    navigate('/demo/conversations/demo-conversation-123/full-questions');
  };

  const handleSelfReflection = () => {
    nextDemoStep();
    // Navigate to self-reflection demo (categories edit page for topic selection)
    navigate('/demo/conversations/demo-conversation-123/categories/edit');
  };

  return (
    <>
      <Header />
      
      <div className="content-wrapper">
        <div className="grid-container">
          <Grid className="grid-padding-x align-justify">
            <Cell small={12}>
              <div className="page-content">
                <h1 className="page-content__title" style={{ 
                  color: 'var(--color--brand-secondary);', 
                  fontSize: '2.5rem', 
                  fontWeight: '900',
                  textTransform: 'uppercase',
                  marginBottom: '20px'
                }}>
                  CHOOSE YOUR ROUTE
                </h1>

                <div className="page-content__styles">
                  <p style={{ fontSize: '1.1rem', color: '#3F3F3F', marginBottom: '40px' }}>
                    To help you to prepare in a way that best suits you, you have two slightly
                    different options. It doesn't matter which of these options you pick, both
                    allow you the opportunity to feedback to your manager on the issues you'd like
                    to discuss.
                  </p>
                </div>

                <Grid className="grid-padding-x align-justify">
                  <Cell small={12} large={5}>
                    <div className="basic-form basic-form--background" style={{
                      backgroundColor: '#f9f9f9',
                      padding: '30px',
                      borderRadius: '10px',
                      marginBottom: '20px'
                    }}>
                      <p className="basic-form__subtitle" style={{
                        color: 'var(--color--brand-secondary);',
                        fontSize: '1.5rem',
                        fontWeight: '700',
                        marginBottom: '20px'
                      }}>
                        Guided route
                      </p>

                      <p style={{ marginBottom: '15px', color: '#3F3F3F' }}>
                        For the curious who are interested in considering their work
                        characteristics using insightful data reflecting their experiences at
                        work.
                      </p>

                      <p style={{ fontWeight: '600', marginBottom: '15px', color: '#3F3F3F' }}>This involves:</p>

                      <ul style={{ marginBottom: '30px', paddingLeft: '20px', color: '#3F3F3F' }}>
                        <li style={{ marginBottom: '10px' }}>
                          Completion of a well-known and scientifically validated survey that asks
                          you to score various aspects of your work
                        </li>
                        <li style={{ marginBottom: '10px' }}>
                          Summary of your results, providing a list of three priorities based on
                          your responses
                        </li>
                        <li style={{ marginBottom: '10px' }}>
                          Opportunity to learn more about your results and consider how well they
                          reflect your current challenges
                        </li>
                      </ul>

                      <button
                        onClick={handleGuidedRoute}
                        className="page-content__button--medium"
                        style={{
                          backgroundColor: 'var(--color--brand-secondary);',
                          color: '#FFFFFF',
                          border: 'none',
                          borderRadius: '10px',
                          padding: '10px 20px',
                          fontSize: '1rem',
                          fontWeight: '600',
                          cursor: 'pointer',
                          transition: 'background-color 0.2s ease'
                        }}
                        onMouseEnter={(e) => e.target.style.backgroundColor = 'var(--color--brand-secondary-hover)'}
                        onMouseLeave={(e) => e.target.style.backgroundColor = 'var(--color--brand-secondary);'}
                      >
                        Next Step
                      </button>
                    </div>
                  </Cell>

                  <Cell small={12} large={2} className="text-center">
                    <div className="basic-form">
                      <p className="basic-form__subtitle" style={{
                        color: 'var(--color--brand-secondary);',
                        fontSize: '1.5rem',
                        fontWeight: '700',
                        textAlign: 'center',
                        margin: '50px 0'
                      }}>
                        or
                      </p>
                    </div>
                  </Cell>

                  <Cell small={12} large={5}>
                    <div className="basic-form basic-form--background" style={{
                      backgroundColor: '#f9f9f9',
                      padding: '30px',
                      borderRadius: '10px',
                      marginBottom: '20px'
                    }}>
                      <p className="basic-form__subtitle" style={{
                        color: 'var(--color--brand-secondary);',
                        fontSize: '1.5rem',
                        fontWeight: '700',
                        marginBottom: '20px'
                      }}>
                        Self-reflection
                      </p>

                      <p style={{ marginBottom: '15px', color: '#3F3F3F' }}>
                        For those who don't feel the need for structured guidance, there is a more
                        autonomous route that allows you time to reflect.
                      </p>

                      <p style={{ fontWeight: '600', marginBottom: '15px', color: '#3F3F3F' }}>This involves:</p>

                      <ul style={{ marginBottom: '30px', paddingLeft: '20px', color: '#3F3F3F' }}>
                        <li style={{ marginBottom: '10px' }}>
                          Presentation of the most common characteristics related to employee
                          mental health in the workplace
                        </li>
                        <li style={{ marginBottom: '10px' }}>
                          Reflection time around the characteristics presented to you
                        </li>
                      </ul>

                      <button
                        onClick={handleSelfReflection}
                        className="page-content__button--medium"
                        style={{
                          backgroundColor: 'var(--color--brand-secondary);',
                          color: '#FFFFFF',
                          border: 'none',
                          borderRadius: '10px',
                          padding: '10px 20px',
                          fontSize: '1rem',
                          fontWeight: '600',
                          cursor: 'pointer',
                          transition: 'background-color 0.2s ease'
                        }}
                        onMouseEnter={(e) => e.target.style.backgroundColor = 'var(--color--brand-secondary-hover)'}
                        onMouseLeave={(e) => e.target.style.backgroundColor = 'var(--color--brand-secondary);'}
                      >
                        Next Step
                      </button>
                    </div>
                  </Cell>
                </Grid>
              </div>
            </Cell>
          </Grid>
        </div>
      </div>
    </>
  );
}
